import { Component } from 'react'
import { withRouter } from "react-router-dom";
import Permission from '../utils/permission';
import Action from '../utils/operationsActions';
import ChangePhoneNumber from '../actionsGroups/changePhoneNumber';
import {
    CancelRequest, ViewFeesModels, ViewCompanyDetails, SendUserOtp, CreateDepartments, DeployCompany, CreateUser,
    CommonDrawer, MainLayoutGroups, ModalComponent, OutPutResult, CreateCompanyGroup, CreateUserComment,
    CreateFeesModel, CreateFeesGroup, ViewFeesGroups, ViewFeesCompanies, EditCompaniesFees, ViewRequestsList,
    RevokeRequest, ViewUserSalary, ResolveIssues, ResolveIssuesByDate, BulkUpdateUserStatus, ApproveUserDocs, ViewUserSuspending,
    UserUnSuspending, CompaniesGroup, ViewUserStatus, UpdateUserCompany, GetBlockingIssues,
    BulkRecalculateRequest, BulkCreateComments, BulkUpdateRequestsStatus, BulkCreateUserInfo, UpdateRequest, ViewResetPassword,
    ZohoTest, ViewRequestInfo, EditUserInfo, BulkUpdateUserInfo, ViewEditApprovedUserSInfo, ViewRequestFees,
    ViewUpdateBankInfo, UpdateUserCaps, ViewAssignUser, ViewUserInfo, BulkUpdateApprovedUsersInfo, SuspendGlobalServices,
    AssignUserRoles, UnAssignUserRoles, CreateRequest, UpdateGlobalCaps, ViewUpdateCompanyCaps, SuspendCompanyServices,
    UploadUserDocs, EditCompany, CreateCompany, StartingCall, TransactingUsers, UpdateDepartment,
} from '@operations/shared';
import SmsNotification from '../actionsGroups/smsNotification';
import OfflineShoppingTransactions from '../actionsGroups/offlineShoppingTransactions';
import { connect } from 'react-redux';
import { stepperMoving, emptyDrawer, move, hrStepper } from '../stores/actions';
import CreateWelcomeEmail from '../actionsGroups/createWelcomeEmail/createWelcomeEmail';
import {
    updateBulkApprovedUsersAdvanced, addCatagoriesApi, addBrandsApi, createPartnersTypesApi,
    addRequestsCommentsApi, addUsersCommentsApi, uploadApprovedUserDocsApi, uploadUserDocsApi,
} from '../utils/apisConsts';
import ViewDeductions from '../actionsGroups/deductions/viewDeductions';
import ApproveInvoice from '../actionsGroups/approveInvoice/approveInvoice';
import BulkUploadCollections from '../actionsGroups/bulkUploadCollection';
import helper from '../utils/helper';
import { ConfigProvider } from 'antd';
import CreateAdjustment from '../actionsGroups/createAdjustment/createAdjustment';
import DeleteAdjustment from '../actionsGroups/deleteAdjustment/deleteAdjustment';
import { bulkUpdateApprovedUserAllInfoTemplate, createRequestsCommentsTemplate, createUsersCommentsTemplate } from '../utils/bulkSheetsTemplates';
import CreateLost from '../actionsGroups/createLostCase/createLost';
import LostCollection from '../actionsGroups/lostCollection/lostCollection';
import DeleteLost from '../actionsGroups/deleteLost/deleteLost';
import BestSellersProds from '../actionsGroups/onlineShopping/products/bestSellersProds';
import PopularPartner from '../actionsGroups/offlineShopping/popularPartner/popularPartner';
import BulkCreateProducts from '../actionsGroups/bulkCreateProducts/bulkCreateProducts';
import DeleteDebitAndCredit from '../actionsGroups/deleteDebitAndCredit/deleteDebitAndCredit';
import BulkUpdateProducts from '../actionsGroups/bulkUpdateProducts/bulkUpdateProducts';
import OnlineTransactions from '../actionsGroups/onlineTransactions';
import Schedule from '../actionsGroups/analytics/schedule';
import Demand from '../actionsGroups/analytics/demand';
import DeleteSchedule from '../actionsGroups/analytics/deleteSchedule';
import BulkCreateMeezaRequests from '../actionsGroups/bulkCreateMeezaRequests';
import TerminateAnalytics from '../actionsGroups/analytics/terminateAnalytics';
import RefundInActiveRequest from '../actionsGroups/refundInActiveRequest/refundInActiveRequests';
import ApproveNewInvoice from '../actionsGroups/approveInvoiceV2/approve';
import ClearRefund from '../actionsGroups/clearRefund';
import RefundActiveRequest from '../actionsGroups/refundActiveRequest/refundActiveRequest';
import CreateExceptLost from '../actionsGroups/createLostCase/createExecpLost';
import CreateExceptionAdjustment from '../actionsGroups/createAdjustment/createExceptionAdjustment';
import AmanBalance from '../actionsGroups/aman/amanBalance';
import BulkUploadLostCollection from '../actionsGroups/bulkLostCollection/Index';
import ViewAtmCheckoutRequest from '../actionsGroups/ViewAtmCheckoutRequest/ViewAtmCheckoutRequest';
import SuspendFreePeriod from '../actionsGroups/viewOffers/Index';
import EarlySettlement from '../actionsGroups/EarlySettlement/EarlySettlement';
import ChangePendingUserCompany from '../actionsGroups/changePendingUserCompany/Index';
import ChangePendingUserStatus from '../actionsGroups/changePendingUserStatus/Index';
import ViewVipUsers from "../actionsGroups/vipUsers/viewVipUsers";
import DeleteExceptionAdjustement from '../actionsGroups/deleteExceptionAdjustment/deleteExceptionAdjustment';
import DeleteExceptionLostRequest from '../actionsGroups/deleteExceptionLostRequest/deleteExceptionLostRequest';
import UploadUserPaymentSlips from '../actionsGroups/uploadUserPaymentSlips/uploadUserPaymentSlips';
import CreatePartner from '../actionsGroups/createPartner';
import CreatePartnerBranches from '../actionsGroups/createPartnerBranches/createPartnerBranches';
import CategoriesAndBrands from '../actionsGroups/categoriesAndBrands';
import EditPartnerBranch from '../actionsGroups/editPartnerBranch/editPartnerBranch';
import EditPartner from '../actionsGroups/editPartner/editPartner';
import EditCompanyBranches from '../actionsGroups/companyBranches/editCompanyBranches';
import BulkUploadCompanyBranches from '../actionsGroups/companyBranches/bulkUploadCompanyBranches';
import EditAndDeleteCollection from '../actionsGroups/editAndDeleteCollection/Index';
import CreateOffer from '../actionsGroups/CreateOffer/CreateOffer';
import ViewAndAssignUnidentifiedCollection from '../actionsGroups/assignUnidentifiedCollection';
import AddUnidentifiedCollection from '../actionsGroups/addUnidentifiedCollection';
import BulkCreateClearance from '../actionsGroups/bulkCreateClearance';
import BulkCallInfo from '../actionsGroups/bulkCallInfo';
import { IDatCategoryProps, ICategoriesState } from '@operations/shared/src/utils/commonInterfaces';
const intFrameWidth: number = window.innerWidth;
const FULL_WIDTH = intFrameWidth <= 500 ? 370 : intFrameWidth - 160;
const FULL_WIDTH_HR = intFrameWidth <= 500 ? 370 : intFrameWidth - 200;

const ACTION_CONFIG: Record<string, { width?: number; component: () => JSX.Element }> = {
    changePhoneNumber: { component: () => <ChangePhoneNumber /> },
    updateBulkUsers: { width: 1282, component: () => <BulkUpdateUserInfo /> },
    createBulkUsers: { width: 1282, component: () => <BulkCreateUserInfo /> },
    createRequest: { width: 1100, component: () => <CreateRequest noLimits={false} /> },
    createExceptionRequest: { width: 1100, component: () => <CreateRequest noLimits={true} /> },
    cancelRequest: { width: 1000, component: () => <CancelRequest /> },
    smsNotification: { component: () => <SmsNotification /> },
    createCompany: { width: 1000, component: () => <CreateCompany /> },
    cancelMerchantRequest: { width: FULL_WIDTH, component: () => <OfflineShoppingTransactions /> },
    createServicesGroup: { width: 820, component: () => <CreateFeesGroup /> },
    createFeesModel: { width: 820, component: () => <CreateFeesModel /> },
    getServiceGroup: { width: 820, component: () => <ViewFeesGroups /> },
    getModelsFeesDetails: { width: 1200, component: () => <ViewFeesModels /> },
    getCompaniesFees: { width: 820, component: () => <ViewFeesCompanies /> },
    addCallInfo: { width: 1000, component: () => <StartingCall /> },
    getUserInfo: { width: 1000, component: () => <ViewUserInfo /> },
    getAllRequests: { width: FULL_WIDTH, component: () => <ViewRequestsList /> },
    updateUserInfo: { width: 1000, component: () => <EditUserInfo /> },
    changeDeploymentStatus: { width: 1000, component: () => <DeployCompany /> },
    getOneCompany: { width: 1000, component: () => <ViewCompanyDetails /> },
    approveHighAmount: { width: 1000, component: () => <ViewRequestInfo /> },
    testZohoTicket: { width: 1000, component: () => <ZohoTest /> },
    assignUserToFeesModel: { width: 1000, component: () => <ViewAssignUser /> },
    createPartner: { component: () => <CreatePartner /> },
    updatePartner: { component: () => <EditPartner /> },
    approveUserDocs: { width: 1000, component: () => <ApproveUserDocs /> },
    createPartnerBranches: { width: 1300, component: () => <CreatePartnerBranches /> },
    updatePartnerBranch: { component: () => <EditPartnerBranch key={Date.now()} /> },
    createCompanyGroup: { component: () => <CreateCompanyGroup /> },
    createWelcomeEmail: { component: () => <CreateWelcomeEmail /> },
    getCompaniesGroups: { width: 1000, component: () => <CompaniesGroup /> },
    getDeductions: { width: 1280, component: () => <ViewDeductions generateInvoice={false} /> },
    generateInvoice: { width: 1280, component: () => <ViewDeductions generateInvoice={true} /> },
    lockPaymentCycle: { width: 1000, component: () => <ApproveInvoice lock={true} /> },
    getUserLastOtp: { component: () => <SendUserOtp /> },
    sendOtpViaTwilio: { component: () => <SendUserOtp /> },
    updateStatus: { width: 1000, component: () => <ViewUserStatus /> },
    updateUserSalary: { width: 1100, component: () => <ViewUserSalary /> },
    updateBankInfo: { width: 1100, component: () => <ViewUpdateBankInfo /> },
    updateApprovedUserInfo: { width: 1000, component: () => <ViewEditApprovedUserSInfo /> },
    updateBulkStatus: { width: 1282, component: () => <BulkUpdateUserStatus /> },
    suspendUser: { width: 1100, component: () => <ViewUserSuspending /> },
    unSuspendUser: { width: 1100, component: () => <UserUnSuspending /> },
    updateForceResetPassword: { width: 1100, component: () => <ViewResetPassword /> },
    uploadUserDocs: { width: 1000, component: () => <UploadUserDocs apiLink={uploadUserDocsApi} /> },
    uploadApprovedUserDocs: { width: 1000, component: () => <UploadUserDocs apiLink={uploadApprovedUserDocsApi} /> },
    updateGlobalServicesCaps: { width: 1000, component: () => <UpdateGlobalCaps /> },
    updateCompanyCap: { width: 1000, component: () => <ViewUpdateCompanyCaps /> },
    updateUserCap: { width: 1000, component: () => <UpdateUserCaps /> },
    updateGlobalServiceSuspension: { width: 1000, component: () => <SuspendGlobalServices /> },
    updateCompanySuspension: { width: 1000, component: () => <SuspendCompanyServices /> },
    assignUserToRole: { width: 1000, component: () => <AssignUserRoles /> },
    unAssignUserFromRole: { width: 1000, component: () => <UnAssignUserRoles /> },
    updateUserCompany: { width: 1200, component: () => <UpdateUserCompany /> },
    updateBulkApprovedUsers: { width: 1282, component: () => <BulkUpdateApprovedUsersInfo /> },
    transactingUsers: { width: FULL_WIDTH_HR, component: () => <TransactingUsers /> },
    revokeRequest: { width: 1282, component: () => <RevokeRequest /> },
    createBulkMeezaCards: { width: 1282, component: () => <BulkCreateMeezaRequests /> },
    clearanceTransactions: { width: 1282, component: () => <BulkCreateClearance /> },
    addCollections: { width: 1282, component: () => <BulkUploadCollections /> },
    createAdjustment: { width: 1000, component: () => <CreateAdjustment /> },
    deleteAdjustment: { width: 1000, component: () => <DeleteAdjustment /> },
    updateCompanyInfo: { width: 1000, component: () => <EditCompany editAllInfo={false} /> },
    updateCompanyInfoAdvance: { width: 1000, component: () => <EditCompany editAllInfo={true} /> },
    bestSellerToggle: { width: 1282, component: () => <BestSellersProds /> },
    partnerPopularToggle: { width: 1282, component: () => <PopularPartner /> },
    updateBulkApprovedUsersAdvanced: { width: 1282, component: () => <BulkUpdateApprovedUsersInfo template={bulkUpdateApprovedUserAllInfoTemplate} api={updateBulkApprovedUsersAdvanced} /> },
    createLostRequest: { width: 1000, component: () => <CreateLost /> },
    createExceptionLost: { width: 1000, component: () => <CreateExceptLost /> },
    createLostCollection: { width: 1000, component: () => <LostCollection /> },
    deleteLostRequest: { width: 1000, component: () => <DeleteLost /> },
    deleteDebitCredit: { width: 1000, component: () => <DeleteDebitAndCredit /> },
    unlockPaymentCycle: { width: 1000, component: () => <ApproveInvoice lock={false} /> },
    categories: { component: () => <CategoriesAndBrands name="Categories" isCategories={true} apiLink={addCatagoriesApi} /> },
    brands: { component: () => <CategoriesAndBrands name="Brands" isCategories={false} apiLink={addBrandsApi} /> },
    bulkCreateProducts: { width: 1000, component: () => <BulkCreateProducts /> },
    bulkUpdateProducts: { width: 1000, component: () => <BulkUpdateProducts /> },
    onlineShoppingRequests: { width: 1200, component: () => <OnlineTransactions /> },
    createPartnerType: { component: () => <CategoriesAndBrands name="Partner Type" isCategories={true} apiLink={createPartnersTypesApi} isPartnerTypes={true} /> },
    createRefundRequest: { width: 1150, component: () => <RefundInActiveRequest /> },
    callAnalyticsApi: { component: () => <Demand /> },
    scheduleAnalyticsApi: { component: () => <Schedule /> },
    deleteScheduledAnalyticsApi: { component: () => <DeleteSchedule /> },
    terminateAnalyticsApi: { component: () => <TerminateAnalytics /> },
    resolveAdvanceIssuesManually: { width: 1200, component: () => <ResolveIssues /> },
    resolveAdvancesIssuesAutomatically: { component: () => <ResolveIssuesByDate /> },
    newDeductions: { width: 1200, component: () => <ApproveNewInvoice lock /> },
    clearAdvanceRefund: { component: () => <ClearRefund /> },
    refundActiveRequest: { width: 1150, component: () => <RefundActiveRequest /> },
    bulkChangeRequestsStatus: { width: 1100, component: () => <BulkUpdateRequestsStatus /> },
    updateRequest: { width: 1100, component: () => <UpdateRequest noLimits={false} /> },
    addRequestsComments: { width: 1100, component: () => <BulkCreateComments template={createRequestsCommentsTemplate} title="Request" api={addRequestsCommentsApi} /> },
    addUsersComments: { width: 1100, component: () => <BulkCreateComments template={createUsersCommentsTemplate} title="User" api={addUsersCommentsApi} /> },
    recalculateRequests: { width: 1100, component: () => <BulkRecalculateRequest /> },
    createDepartments: { width: 1100, component: () => <CreateDepartments /> },
    updateDepartmentBalancePercent: { width: 1100, component: () => <UpdateDepartment /> },
    importCallCenterReport: { width: 1100, component: () => <BulkCallInfo /> },
    userCreateSingleComment: { width: 1100, component: () => <CreateUserComment /> },
    getBlockingIssues: { width: 1200, component: () => <GetBlockingIssues /> },
    createUser: { component: () => <CreateUser /> },
    getAmanBalance: { component: () => <AmanBalance /> },
    createExceptionAdjustment: { width: 900, component: () => <CreateExceptionAdjustment /> },
    viewRequestFees: { width: 900, component: () => <ViewRequestFees /> },
    assignCompanyToFeesModel: { width: 900, component: () => <EditCompaniesFees isDeployedCompany /> },
    assignNonDeployedCompanyToFeesModel: { width: 900, component: () => <EditCompaniesFees isDeployedCompany={false} /> },
    settleATMRequest: { width: 1200, component: () => <ViewAtmCheckoutRequest /> },
    bulkCreateLostCollections: { width: 900, component: () => <BulkUploadLostCollection /> },
    createFreePeriodOffer: { width: 900, component: () => <CreateOffer /> },
    viewAndSuspendFreePeriodOffer: { width: 1300, component: () => <SuspendFreePeriod /> },
    addExternalPaymentWithEarlySettlment: { width: 1300, component: () => <EarlySettlement /> },
    changePendingUserCompany: { width: 900, component: () => <ChangePendingUserCompany /> },
    changePendingUserStatus: { width: 900, component: () => <ChangePendingUserStatus /> },
    forceDeleteAdjustment: { width: 900, component: () => <DeleteExceptionAdjustement /> },
    forceDeleteLost: { width: 900, component: () => <DeleteExceptionLostRequest /> },
    testChatGPT: { width: 900, component: () => <ViewVipUsers /> },
    uploadUserSlips: { width: 900, component: () => <UploadUserPaymentSlips /> },
    getCompanyBranches: { width: 900, component: () => <EditCompanyBranches /> },
    createCompanyBranches: { width: 900, component: () => <BulkUploadCompanyBranches /> },
    getInvoiceCollections: { width: 1100, component: () => <EditAndDeleteCollection /> },
    assignUnidentifiedCollection: { width: 1100, component: () => <ViewAndAssignUnidentifiedCollection /> },
    addUnidentifiedCollection: { width: 900, component: () => <AddUnidentifiedCollection /> },
};

const PERMISSION_DENIED_VIEW = (actionName: string) => ({
    layout: <OutPutResult status="403" title="Permission Issue" subTitle={`${helper.unCamelCase(actionName)} action is out of your permissions`} />,
    title: 'Out Of Permissions',
});



class Categories extends Component<IDatCategoryProps, ICategoriesState> {
    state: ICategoriesState = {
        loading: false,
        drawerLayout: null,
        drawerTitle: '',
        visibleDrawer: false,
        drawerWidths: null,
        hiddenScroll: false,
        dataForm: {},
        visibleChildDrawer: false,
        visibleModal: false,
        inputChange: false,
    };

    componentDidMount() {
        this.openDrawerByDynamicId();
    }

    componentDidUpdate(prevProps: any, prevState: ICategoriesState) {
        if (!this.state.inputChange && prevState.inputChange === this.state.inputChange && this.getInputs(true).length > 2) {
            this.setState({ inputChange: true });
        }
        const prevAction = prevProps.match?.params?.actionName;
        const nextAction = this.props.match?.params?.actionName;
        const prevTarget = `${(prevProps.location?.pathname || '').split('/').filter(Boolean)[0] || ''}/${prevAction || ''}`;
        const nextTarget = `${(this.props.location?.pathname || '').split('/').filter(Boolean)[0] || ''}/${nextAction || ''}`;
        if (nextAction && prevTarget !== nextTarget) {
            this.openDrawerByDynamicId();
        }
    }

    activeAction = (actionName: string) => {
        const config = ACTION_CONFIG[actionName];
        if (!config) return undefined;
        this.setState({ drawerWidths: config.width ?? 820, hiddenScroll: false });
        return config.component();
    };

    openDrawerByDynamicId = () => {
        const { actionName } = this.props.match.params;
        if (!actionName) return;

        this.props.emptyDrawer(true);
        const availableActions: string[] = Permission.handleGettingPermission('permission');
        const actions = Action.actionsCreated();
        const matched = actions.find((a: { actionName: string }) => a.actionName === actionName);

        if (!matched) {
            const layout = this.activeAction(actionName);
            if (!layout) return;
            this.setState({ visibleDrawer: true, drawerLayout: layout, drawerTitle: helper.unCamelCase(actionName) });
            return;
        }

        const { layout, title } = availableActions.includes(actionName)
            ? { layout: this.activeAction(actionName), title: matched.name }
            : PERMISSION_DENIED_VIEW(actionName);

        this.setState({ visibleDrawer: true, drawerLayout: layout ?? null, drawerTitle: title });
    };

    selectedAction = (actionData: any) => {
        this.props.emptyDrawer(true);
        this.props.history.push(`${this.props.location.pathname}/${actionData.actionName}`);
        this.setState({
            visibleDrawer: true,
            drawerLayout: this.activeAction(actionData.actionName) ?? null,
            drawerTitle: actionData.name,
        });
    };

    getInputs = (onlyInputs?: boolean) => {
        const inputs = Array.from(document.getElementsByTagName("input"));
        const textareas = Array.from(document.getElementsByTagName("textarea"));
        if (onlyInputs) return [...inputs, ...textareas];
        return [...inputs, ...textareas, ...Array.from(document.getElementsByTagName("button"))];
    };

    openModal = () => this.setState({ visibleModal: true });

    cancelDrawer = () => {
        const hasValues = this.getInputs().some(el => (el as HTMLInputElement).value);
        if (hasValues || (this.state.inputChange && this.props.stepNumber > 0)) {
            this.openModal();
            return;
        }
        this.confirmationModal();
    };

    confirmationModal = () => {
        Array.from(document.getElementsByTagName("form")).forEach(f => f.reset());
        this.setState({ visibleDrawer: false, visibleModal: false, drawerWidths: null });
        this.props.history.push(`/${Permission.handleGettingPath()}`);
        this.props.stepperMoving(0);
        this.props.move(0);
        this.props.hrStepper(0);
        this.props.emptyDrawer(false);
        helper.resetAccountTableInStepper();
    };

    handleCloseModal = () => this.setState({ visibleModal: false });

    render() {
        const { visibleModal, drawerLayout, drawerTitle, visibleDrawer, drawerWidths, hiddenScroll } = this.state;
        const isArabic = helper.isArabic(drawerTitle);

        return (
            <>
                <MainLayoutGroups
                    groupActions={Action.actionsCreated()}
                    selectedAction={this.selectedAction}
                    permission={Permission.handleGettingPermission('permission')}
                />
                <CommonDrawer
                    drawerLayout={drawerLayout}
                    drawerWidth={drawerWidths ?? 820}
                    drawerTitle={drawerTitle}
                    visible={visibleDrawer}
                    showDrawer={this.selectedAction}
                    cancelDrawer={this.cancelDrawer}
                    hiddenScroll={hiddenScroll}
                />
                {isArabic ? (
                    <ConfigProvider direction='rtl'>
                        <ModalComponent
                            okText='نعم' cancelText='لا'
                            visibleModal={visibleModal}
                            handleAcceptModal={this.confirmationModal}
                            content={<p style={{ fontSize: '17px', fontWeight: 'lighter' }}>انت ستغادر هذه الصفحه. هل أنت متأكد؟</p>}
                            title='تحذير'
                            handleCloseModal={this.handleCloseModal}
                        />
                    </ConfigProvider>
                ) : (
                    <ModalComponent
                        okText='Yes' cancelText='No'
                        visibleModal={visibleModal}
                        handleAcceptModal={this.confirmationModal}
                        content={<p style={{ fontSize: '17px', fontWeight: 'lighter' }}>You have attempted to leave this page. Are you sure?</p>}
                        title='Warning Message'
                        handleCloseModal={this.handleCloseModal}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({ stepNumber: state.actionsReducer.stepNumber });

export default withRouter(connect(mapStateToProps, { stepperMoving, move, hrStepper, emptyDrawer })(Categories));
